<template>
  <div>
    <div class="ligne" @click="selectLine(node)">
      <!--  <div
        v-if="colCheckbox && nodeSelected.level<node.level"
        class="col-checkbox"
        :style="'width:10%; text-align:center'"
      >
        <v-checkbox
          color="#fec90a"
          class="checkbox-node-line"
          hide-details
          v-model="node.checked"
          @change="checkedNode(node)"
        ></v-checkbox>
      </div>-->
      <!-- <div class="family-name" :class="'level'+node.level ">
        <div @click.stop="open(node)" v-if="node.opened">
          <icon class="mr-2" name="caret-down"></icon>
          <icon class="mr-2" name="folder-open" :style="`color:${node.color};`"></icon>
        </div>
        <div @click.stop="open(node)" v-if="!node.opened">
          <icon class="mr-2" name="caret-right"></icon>
          <icon class="mr-2" name="folder" :style="`color:${node.color};`"></icon>
        </div>

        <div>
          {{getFamilylevel(node)}}
          <span class="bis">{{getnodeName()}}</span>
        </div>
      </div>-->
      <!-- <div class="nombre-product d-flex flex-row" :style="'width:10%; text-align:left'">
        <div v-if="this.node.name !== 'root'">{{node.nbProducts}}</div>
      </div>-->
      <!-- <div :style="'width:10%; text-align:left'" class="d-flex flex-row">
        <div
          v-if="this.node.name !== 'root' && colEdit"
          class="icon-show-products withpointer"
          @click.stop="editLine(node.id, node.level, node.name)"
        >
          <icon class="mr-2" name="edit"></icon>
        </div>
        <div
          class="icon-show-products ml-2 withpointer"
          @click.stop="addProductToNode(node.id, node, node.name)"
        >
          <icon v-if="ca_id!==0" class="mr-2" name="plus"></icon>
        </div>
        <div
          v-if="this.node.name !== 'root'"
          class="icon-show-products ml-2 withpointer"
          @click.stop="deleteWinConfirm(node.id, node.level, node.name)"
        >
          <icon v-if="ca_id!==0" class="mr-2" name="trash"></icon>
        </div>
      </div>-->
      <v-toolbar-items v-if="colProblems" :style="'width:10%; text-align:left'">
        <v-menu
          :open-on-hover="true"
          :close-on-click="true"
          :close-on-content-click="true"
          :offset-y="true"
        >
          <template v-slot:activator="{ on }">
            <div class="d-flex flex-row" v-if="node.nbProblems" v-on="on">
              <div
                v-if="node.name !== 'root'"
                class="icon-show-products withpointer col-problems d-flex flex-row"
              >
                <icon class="mr-2" name="exclamation-triangle"></icon>
                <div>{{node.nbProblems}}</div>
              </div>
            </div>
          </template>
          <div class="dropdown-pb">
            <div class="bis">{{node.problems.length}} problèmes sur ce dossier :</div>
            <div v-for="(pb, i) in node.problems" :key="i">{{pb.text}}</div>
            <br />
            <div>{{node.nbProblems - node.problems.length}} autres problèmes à l'intérieur du dossier</div>
          </div>
        </v-menu>
      </v-toolbar-items>
    </div>
    <div v-if="node.opened">
      <card-tree-family-line
        v-for="(child,index) in node.children"
        :key="index"
        :node="child"
        :updatenow="updatenow"
        @opened="opened"
        :path="path"
        :colCheckbox="colCheckbox"
        :colProblems="colProblems"
        :colEdit="colEdit"
        :ca_id="ca_id"
        :canSelectLine="canSelectLine"
        :nodeSelected="nodeSelected"
        @productWinEditOpened="$emit('productWinEditOpened')"
        @productWinEditCanceled="$emit('productWinEditCanceled')"
        @productWinEditSaved="$emit('productWinEditSaved')"
        @select="select"
        @saved="saved"
        @deleteWinConfirm="deleteWinConfirm"
        @rerender="$emit('rerender')"
      ></card-tree-family-line>
      <card-tree-product-line
        v-for="(product,indexProduct) in node.products"
        :key="indexProduct+1000"
        :colFamily="false"
        :product="product"
        :colCheckbox="colCheckbox"
        :colProblems="colProblems"
        :level="product.level"
        @deleteWinConfirmProduct="deleteWinConfirmProduct"
        @productWinEditOpened="$emit('productWinEditOpened')"
        @productWinEditCanceled="$emit('productWinEditCanceled')"
        @productWinEditSaved="$emit('productWinEditSaved')"
      ></card-tree-product-line>
    </div>
    <!-- <m-family-win-edit ref="familywinedit" @familyWinEditSaved="familyWinEditSaved" :ca_id="ca_id"></m-family-win-edit>
    <m-catalog-add-product ref="catalogaddproduct" @saved="saved" :nodeSelected="nodeSelected"></m-catalog-add-product>-->
    <m-confirm-dialog
      v-model="confirmDeleteProduct"
      :text="`Souhaitez-vous vraiment ce produit : ${productTodelete} ?`"
      title="Confirmation"
      @canceled="confirmDeleteProduct=false"
      @confirmed="deleteWinProduct()"
    ></m-confirm-dialog>
  </div>
</template>

<script>
export default {
  name: "card-tree-family-line",
  components: {},
  props: {
    updatenow: Number,
    node: Object,
    products: Array,
    width: String,
    colCheckbox: Boolean,
    colEdit: Boolean,
    colProblems: Boolean,
    path: String,
    ca_id: Number,
    catalogName: String,
    nodeSelected: Object,
    canSelectLine: Boolean
  },
  data() {
    return {
      confirmDeleteProduct: false,
      productTodelete: "",
      prIdToDelete: null
    };
  },
  watch: {
    updatenow() {
      this.$forceUpdate();
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    /*  getFamilylevel(child) {
      let family = "";
      if (child.level === 1) family = "FAMILLE ";
      if (child.level === 2) family = "SOUS-FAMILLE ";
      if (child.level === 3) family = "SEGMENT ";
      return family;
    },
    getnodeName() {
      if (this.ca_id === 0 && this.node.name === "root") return "Matrice";
      if (this.ca_id !== 0 && this.node.name === "root")
        return this.catalogName;
      else {
        return this.node.name;
      }
    }, */

    /*     async open(node) {
      node.opened = !node.opened;
      this.opened(node);
    },
    opened(node) {
      this.$emit("opened", node);
    }, */
    /* createLine(selectedNode) {
      this.$router.push(this.path + "/family/edit/-1");
      this.$refs.familywinedit.open(
        -1,
        selectedNode.level,
        "",
        this.ca_id,
        selectedNode
      );
    }, */
    /* editLine(fa_id, level, name) {
      this.$router.push(this.path + "/family/edit/" + fa_id);
      this.$refs.familywinedit.open(fa_id, level, name, this.ca_id);
    },
    addProductToNode(fa_id, node, name) {
      this.$refs.catalogaddproduct.open(fa_id, node, name, this.ca_id);
    },
    deleteWinConfirm(fa_id, level, name) {
      this.$emit("deleteWinConfirm", fa_id, level, name);
    },
    deleteWinConfirmProduct(pr_id, name) {
      this.productTodelete = name;
      this.prIdToDelete = pr_id;
      this.confirmDeleteProduct = true;
    },
    async deleteWinProduct() {
      let response = await this.$axios.delete(
        this.$config.server_url + "/api/1.0/Products/" + this.prIdToDelete
      );
      // console.log("fa_id to delete", this.faIdToDelete);
      this.confirmDeleteProduct = false;

      this.$emit("saved");
    }, */
    /*  checkedNode(node) {
      for (let ipr = 0; ipr < node.products.length; ipr++) {
        const product = node.products[ipr];
        product.checked = node.checked;
      }
      for (let ino = 0; ino < node.children.length; ino++) {
        const child = node.children[ino];
        child.checked = node.checked;
        this.checkedNode(child);
      }
      this.$emit("rerender");
    }, */
    select(child) {
      this.$emit("select", child);
      this.$forceUpdate();
    },
    /* selectLine(child) {
      if (child.level === 3) return;
      if (!this.canSelectLine) return;
      this.$emit("select", child);
      this.node.selected = true;
    }, */
    familyWinEditSaved(row_fa) {
      this.$emit("saved");
      /*       console.log("node, row_fa", this.node, row_fa);
      this.node.color = row_fa.fa_color;
      this.node.name = row_fa.fa_name_fr;
      this.$forceUpdate(); */
    },
    saved() {
      this.$emit("saved");
    }
  }
};
</script>
<style lang="scss" scoped>
/* .whiteLine {
  background-color: #fff;
}
.grayLine {
  background-color: #f1f1f1;
}
.selected {
  background-color: #a1a1a1;
}

.family-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 80%;
}

.nombre-product {
  text-align: center;
  margin-right: auto;
}
.product-name {
  display: flex;
  flex-direction: row;
}
.checkbox-node-line {
  margin: 0 0 0 30px;
  padding: 0;
}
.col-problems {
  align-items: center;
}
.dropdown-pb {
  background-color: #fff;
  padding: 10px;
} */
</style>